import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import {
  Grid,
  Paper,
  Snackbar,
  Box,
} from '@material-ui/core';
import { Alert } from '@material-ui/lab';

import {
  selectCompanyCode,
  selectReservationCode,
  selectGuest,
  selectReservation,
} from '../store/widgetSlice';

import {
  clearMessage,
  selectMessage,
  selectSeverity,
} from '../store/authSlice';

import VerifyModal from '../components/modals/VerifyModalDemo';
import RecognizeModal from '../components/modals/RecognizeModal';
import WriteReviewModal from '../components/modals/WriteReviewModal';
import StatusIcon from '../components/common/StatusIcon';
import AddGuestFormDemo from '../components/forms/AddGuestFormDemo';
import logo from '../assets/guest-ranger-logo.svg';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      padding: [theme.spacing(2)],
    },
    maxWidth: 700,
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  logo: {
    maxHeight: 75,
  },
  content: {
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  actions: {
    marginTop: 10,
    paddingTop: 20,
    borderTop: '1px solid rgba(112, 112, 112, 0.15)',
    flexGrow: 1,
  },
  action: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    width: '100%',
    marginBottom: theme.spacing(2),

    '&:last-child': {
      marginBottom: theme.spacing(1),
    },

    [theme.breakpoints.up('sm')]: {
      marginBottom: 0,
    },
  },
}));

export default function Widget() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const companyCode = useSelector(selectCompanyCode);
  const reservationCode = useSelector(selectReservationCode);
  const guest = useSelector(selectGuest);
  // eslint-disable-next-line no-unused-vars
  const reservation = useSelector(selectReservation);
  const message = useSelector(selectMessage);
  const severity = useSelector(selectSeverity);

  const handleClose = () => {
    dispatch(clearMessage());
  };

  return (
    <>
      <Box className={classes.root}>
        <p>
          <b>Current Reservation Code:</b>
          {' '}
          <span>{reservationCode}</span>
          {' '}
          <b>Current Company Code:</b>
          {' '}
          <span>{companyCode}</span>
        </p>
      </Box>
      <Paper className={classes.root} elevation={1}>
        <Snackbar open={!!message} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity={severity}>{message}</Alert>
        </Snackbar>
        <Grid container className={classes.content}>
          <Grid item xs={12} sm={4} justifyContent="center">
            <div className="grwidget__logo-container">
              <a className="grwidget__logo-link" href="https://guestranger.com/" target="_blank" rel="noreferrer">
                <img className={classes.logo} src={logo} alt="Guest Ranger" />
              </a>
            </div>
          </Grid>
          <Grid container xs={12} sm={8} className={classes.status}>
            <Grid item xs={4}>
              <div className="grwidget__status-item">
                <span className="grwidget__status-label">Full Name</span>
                <span className="grwidget__status-icon">
                  <StatusIcon status={guest && ((guest.nameVerified === 1) ? 3 : guest.nameVerified)} />
                </span>
              </div>
            </Grid>
            <Grid item xs={4}>
              <div className="grwidget__status-item">
                <span className="grwidget__status-label">Address</span>
                <span className="grwidget__status-icon">
                  <StatusIcon status={guest && ((guest.addressVerified === 1) ? 3 : guest.addressVerified)} />
                </span>
              </div>
            </Grid>
            <Grid item xs={4}>
              <div className="grwidget__status-item">
                <span className="grwidget__status-label">Payment Card</span>
                <span className="grwidget__status-icon">
                  <StatusIcon status={guest && ((guest.phoneVerified === 1) ? 3 : guest.phoneVerified)} />
                </span>
              </div>
            </Grid>
          </Grid>
          <Grid container className={classes.actions}>
            <Grid item sm={4} className={classes.action}>
              <VerifyModal />
            </Grid>
            <Grid item sm={4} className={classes.action}>
              <RecognizeModal />
            </Grid>
            <Grid item sm={4} className={classes.action}>
              <WriteReviewModal />
            </Grid>
          </Grid>
        </Grid>
      </Paper>
      <Box className={classes.root}>
        <AddGuestFormDemo />
      </Box>
    </>
  );
}
